const React = require('react');

const Container = require('../common/Container.jsx');
const TypeConfig = require('../common/Image.jsx').TypeConfig;
const TypeConfigV2 = require('../common/Image.jsx').TypeConfigV2;
const Utilities = require('../utility/Utilities.jsx');

// MAX DIMS: 711px by 820px <-- do not exceed these or page breaks will occur inside images!!!

function Image(props) {
    const image = props.image || {};
    const hasContent = !Utilities.isNullOrWhitespace(image.S3Id);
    if (!props.builder && !hasContent) {
        return null;
    }
    let blockProps = {};
    let v2;
    if (props.config) {
        if (props.config.Config && props.config.Config.Block) {
            blockProps = props.config.Config.Block;
        } else if (props.config.config && props.config.config.Block) {
            blockProps = props.config.config.Block;
            v2 = true;
        }
    }
    let format = 'c_fit';
    let style = { display: 'inline-block' };
    const itemData = props.itemData || {};
    let url;
    if (hasContent) {
        let height = 0;
        let width = 0;
        if (v2) {
            if (blockProps.maxWidth && !Utilities.isNullOrWhitespace(blockProps.maxWidth.value)) {
                style.maxWidth = `${blockProps.maxWidth.value}${blockProps.maxWidth.unit}`;
                width = `${blockProps.maxWidth.value}`;
            }
            if (blockProps.maxHeight && !Utilities.isNullOrWhitespace(blockProps.maxHeight.value)) {
                style.maxHeight = `${blockProps.maxHeight.value}${blockProps.maxHeight.unit}`;
                height = `${blockProps.maxHeight.value}`;
            }
            if (blockProps.width && !Utilities.isNullOrWhitespace(blockProps.width.value)) {
                style.width = `${blockProps.width.value}${blockProps.width.unit}`;
                width = `${blockProps.width.value}`;
                format = 'c_pad';
            }
            if (blockProps.height && !Utilities.isNullOrWhitespace(blockProps.height.value)) {
                style.height = `${blockProps.height.value}${blockProps.height.unit}`;
                height = `${blockProps.height.value}`;
                format = 'c_pad';
            }
        } else {
            if (!Utilities.isNullOrWhitespace(blockProps.maxWidth)) {
                style.maxWidth = blockProps.maxWidth;
                width = blockProps.maxWidth.replace(/\D/g, '');
            }
            if (!Utilities.isNullOrWhitespace(blockProps.maxHeight)) {
                style.maxHeight = blockProps.maxHeight;
                height = blockProps.maxHeight.replace(/\D/g, '');
            }
            if (!Utilities.isNullOrWhitespace(blockProps.width)) {
                style.width = blockProps.width;
                width = blockProps.width.replace(/\D/g, '');
                format = 'c_pad';
            }
            if (!Utilities.isNullOrWhitespace(blockProps.height)) {
                style.height = blockProps.height;
                height = blockProps.height.replace(/\D/g, '');
                format = 'c_pad';
            }
        }
        if (image.Width >= width * 2 || image.Height >= height * 2) {
            height = height * 2;
            width = width * 2;
        }
        const query = [format];
        if (width > 0) {
            query.push(`w_${width}`);
        }
        if (height > 0) {
            query.push(`h_${height}`);
        }
        if (props.data && props.data.Constants && props.data.Constants.CdnUrl) {
            url = `${props.data.Constants.CdnUrl}${query.join(',')}/${image.S3Id}.${image.Format}`;
        }
    }
    const linkStyle = {};
    if (Utilities.isNullOrWhitespace(itemData.Url)) {
        linkStyle.cursor = 'default';
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            <tr>
                <td>
                    {
                        hasContent &&
                        <div className="fluid-img">
                            <a href={itemData.Url || ''} style={linkStyle}>
                                <img
                                    alt={(props.componentData && props.componentData.alt) || itemData.Title || ''}
                                    border="0"
                                    src={url || ''}
                                    style={style} />
                            </a>
                        </div>
                    }
                    {
                        props.builder &&
                        <React.Fragment>
                            {
                                !hasContent &&
                                Utilities.Builder.emptyBlockPlaceholder()
                            }
                            {Utilities.Builder.dragOutline()}
                        </React.Fragment>
                    }
                </td>
            </tr>
        </Container>
    );
}

module.exports = {
    Component: Image,
    TypeConfig,
    TypeConfigV2
};